const fr = {
  // Login Page
  login: {
    title: 'MedRahi',
    subtitle: 'Connecter les patients avec des soins indiens de confiance',
    emailLabel: 'E-mail',
    emailPlaceholder: 'vous@exemple.com',
    passwordLabel: 'Mot de passe',
    passwordPlaceholder: '••••••••',
    signInButton: 'Se Connecter',
    signingIn: 'Connexion en cours...',
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
  },
  
  // Register Page
  register: {
    title: 'Rejoignez MedRahi',
    subtitle: 'Créez votre compte pour commencer',
    fullNameLabel: 'Nom Complet',
    emailLabel: 'E-mail',
    passwordLabel: 'Mot de passe',
    roleLabel: 'Je suis un',
    rolePatient: 'Patient',
    roleDoctor: 'Médecin',
    roleHospital: 'Hôpital',
    countryLabel: 'Pays',
    countryPlaceholder: 'Votre pays d\'origine',
    phoneLabel: 'Téléphone (Optionnel)',
    createAccountButton: 'Créer un Compte',
    creatingAccount: 'Création du compte...',
    haveAccount: 'Vous avez déjà un compte ?',
    signIn: 'Se connecter',
  },
  
  // Navigation
  nav: {
    treatments: 'Traitements',
    doctors: 'Médecins',
    hospitals: 'Hôpitaux',
    services: 'Services',
    wellness: 'Bien-être',
    medicalVisa: 'Visa Médical',
    signIn: 'Se Connecter',
    getStarted: 'Commencer',
    backToHome: 'Retour à l\'Accueil',
  },
  
  // Services Menu
  servicesMenu: {
    airportPickup: 'Navette Aéroport',
    languageInterpreter: 'Interprète Linguistique',
    surroundingTours: 'Visites Gratuites',
    nursingCare: 'Soins Infirmiers',
    physiotherapist: 'Kinésithérapeute',
    travelAccommodation: 'Voyage et Hébergement',
    videoConsultations: 'Consultations Vidéo',
  },
  
  // Landing Page
  landing: {
    heroTag: 'Approuvé par plus de 10 000 Patients Internationaux',
    heroTitle1: 'Découvrez',
    heroTitle2: 'des Soins Médicaux',
    heroTitle3: 'de Classe Mondiale en Inde',
    heroSubtitle: 'Connectez-vous avec les meilleurs médecins et hôpitaux indiens. Obtenez un traitement médical abordable et de haute qualité avec des prix transparents et des soins personnalisés.',
    ctaStart: 'Commencez Votre Parcours',
    ctaExplore: 'Explorer le Portail',
    isoCertified: 'Certifié ISO',
    nabhAccredited: 'Accrédité NABH',
    jciStandards: 'Normes JCI',
    platformHighlights: 'Points Forts de la Plateforme',
    realTimeStats: 'Statistiques en temps réel',
    activeNow: 'Actif Maintenant',
    verifiedDoctors: 'Médecins Vérifiés',
    partnerHospitals: 'Hôpitaux Partenaires',
    successRate: 'Taux de Réussite',
    patientRating: 'Évaluation des Patients',
    patientsTreated: 'patients traités ce mois-ci',
    
    // Features Section
    whyChoose: 'Pourquoi Choisir MedRahi',
    featuresTitle: 'L\'Excellence Médicale Rencontre l\'Hospitalité Indienne',
    featuresSubtitle: 'Découvrez le mélange parfait de technologie médicale de pointe et de chaleur traditionnelle indienne',
    
    features: {
      transparentPricing: {
        title: 'Tarification Transparente',
        desc: 'Comparez les devis de plusieurs hôpitaux. Pas de coûts cachés. Économisez jusqu\'à 70% par rapport aux pays occidentaux.',
      },
      worldClassFacilities: {
        title: 'Établissements de Classe Mondiale',
        desc: 'Accédez à des hôpitaux accrédités JCI avec une technologie de pointe et des normes internationales.',
      },
      verifiedSpecialists: {
        title: 'Spécialistes Vérifiés',
        desc: 'Connectez-vous avec des médecins certifiés formés internationalement avec des décennies d\'expérience.',
      },
      securePrivate: {
        title: 'Sécurisé et Privé',
        desc: 'Cryptage de niveau bancaire pour vos dossiers médicaux. Protection des données conforme HIPAA.',
      },
      endToEndSupport: {
        title: 'Accompagnement Complet',
        desc: 'De l\'assistance visa aux soins post-traitement. Nous gérons tout pour votre confort.',
      },
      quickResponse: {
        title: 'Réponse Rapide',
        desc: 'Obtenez des devis en 24 heures. Messagerie en temps réel avec les médecins. Rendez-vous instantanés.',
      },
    },
    
    // How It Works
    yourJourney: 'Votre Parcours',
    howItWorksTitle: 'Étapes Simples vers des Soins de Classe Mondiale',
    howItWorksSubtitle: 'De la demande à la guérison, nous sommes avec vous à chaque étape',
    steps: {
      step1: { title: 'Soumettre une Demande', desc: 'Parlez-nous de votre condition et de vos besoins médicaux' },
      step2: { title: 'Comparer les Devis', desc: 'Recevez des devis détaillés de médecins vérifiés' },
      step3: { title: 'Planifier le Traitement', desc: 'Choisissez votre médecin et planifiez vos rendez-vous' },
      step4: { title: 'Recevoir le Traitement', desc: 'Recevez des soins et profitez de votre guérison en Inde' },
    },
    startJourney: 'Commencez Votre Parcours de Traitement',
    
    // Specializations
    popularSpecializations: 'Spécialisations de Traitement Populaires',
    indiaExpertise: 'L\'expertise de l\'Inde couvre tous les domaines médicaux',
    specializations: {
      cardiology: 'Cardiologie',
      orthopedics: 'Orthopédie',
      oncology: 'Oncologie',
      fertility: 'Fertilité',
      dental: 'Dentaire',
      cosmetic: 'Cosmétique',
    },
    
    // For Doctors & Hospitals
    forDoctors: 'Pour les Médecins',
    forDoctorsDesc: 'Rejoignez la principale plateforme de tourisme médical en Inde et connectez-vous avec des patients internationaux recherchant votre expertise.',
    forHospitals: 'Pour les Hôpitaux',
    forHospitalsDesc: 'Associez-vous à MedRahi pour attirer des patients internationaux et présenter vos installations de classe mondiale.',
    registerAsDoctor: 'S\'inscrire en tant que Médecin',
    registerAsHospital: 'S\'inscrire en tant qu\'Hôpital',
    
    doctorBenefits: [
      'Étendez votre pratique mondialement',
      'Demandes de patients vérifiées',
      'Système de tarification transparent',
      'Équipe d\'assistance dédiée',
      'Développez votre réputation',
    ],
    hospitalBenefits: [
      'Augmentez l\'affluence internationale',
      'Présentez votre infrastructure',
      'Gérez les médecins efficacement',
      'Analyses en temps réel',
      'Support marketing',
    ],
    
    // CTA Section
    ctaTitle: 'Prêt à Découvrir les Soins Médicaux Indiens?',
    ctaSubtitle: 'Rejoignez des milliers de patients satisfaits qui ont choisi l\'Inde pour leur traitement médical',
    getStartedNow: 'Commencer Maintenant',
    
    // Footer
    healthcareWithoutBorders: 'Santé Sans Frontières',
    footerDesc: 'Connecter les patients internationaux avec les meilleurs professionnels de santé indiens depuis 2024.',
    quickLinks: 'Liens Rapides',
    contactUs: 'Contactez-nous',
    copyright: '© 2024 MedRahi. Tous droits réservés. Fait avec ❤️ en Inde',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
    cookiePolicy: 'Politique des Cookies',
  },
  
  // Service Pages Common
  services: {
    enquireNow: 'Demander un Devis Gratuit',
    responseTime: 'Réponse sous 24 heures',
    whatsIncluded: 'Ce qui est Inclus',
    
    enquiryForm: {
      fullName: 'Nom Complet',
      email: 'E-mail',
      phone: 'Téléphone',
      country: 'Pays',
      countryPlaceholder: 'Votre pays d\'origine',
      additionalRequirements: 'Exigences Supplémentaires',
      additionalPlaceholder: 'Dites-nous en plus sur vos besoins...',
      cancel: 'Annuler',
      submit: 'Envoyer la Demande',
      successMessage: 'Demande envoyée avec succès! Notre équipe vous contactera sous 24 heures.',
    },
    
    airportPickup: {
      title: 'Service de Navette Aéroport',
      subtitle: 'Transferts aéroport sans stress pour votre voyage médical. Transport sûr, fiable et confortable.',
      mainTitle: 'Bienvenue dans un Voyage Sans Stress',
      mainDesc1: 'Arriver dans un nouveau pays pour un traitement médical peut être accablant. Notre service dédié de navette aéroport garantit que vous commencez et terminez votre voyage médical avec confort et tranquillité d\'esprit.',
      mainDesc2: 'Nos chauffeurs professionnels vous accueilleront à l\'aéroport avec un panneau de bienvenue personnalisé, vous aideront avec vos bagages et vous transporteront en toute sécurité vers votre hébergement ou hôpital.',
      features: {
        availability: { title: 'Disponibilité 24h/24', desc: 'Service 24 heures sur 24 pour les vols tôt le matin ou tard le soir.' },
        safe: { title: 'Sûr et Fiable', desc: 'Chauffeurs expérimentés et agréés avec des véhicules propres.' },
        doorToDoor: { title: 'Service Porte à Porte', desc: 'Transport direct de l\'aéroport à l\'hôtel, l\'hôpital ou tout autre lieu.' },
        flightMonitoring: { title: 'Suivi des Vols', desc: 'Nous suivons l\'état de votre vol pour ajuster les heures de prise en charge.' },
      },
      included: [
        'Accueil aux arrivées avec panneau nominatif',
        'Assistance bagages et navigation aéroport',
        'Véhicules confortables climatisés',
        'Chauffeurs anglophones connaissant les routes hospitalières',
        'Véhicules accessibles aux fauteuils roulants sur demande',
        'Eau en bouteille offerte',
        'Points de charge mobiles dans le véhicule',
        'Temps d\'attente gratuit pour les retards de vol',
      ],
      vehicleOptions: 'Options de Véhicules',
      sedan: { title: 'Berline', desc: 'Pour 1-2 passagers', features: ['Sièges confortables', '2 grandes valises', 'Clim et système audio'] },
      suv: { title: 'SUV', desc: 'Pour 3-4 passagers', features: ['Intérieur spacieux', '4 grandes valises', 'Espace jambes supplémentaire'] },
      minivan: { title: 'Minivan', desc: 'Pour 5-7 passagers', features: ['Familial', '6+ grandes valises', 'Accessible fauteuil roulant'] },
      airportsCovered: 'Principaux Aéroports Desservis',
    },
    
    languageInterpreter: {
      title: 'Services d\'Interprète et Traducteur',
      subtitle: 'Combler le fossé de communication pendant votre voyage médical avec nos interprètes multilingues professionnels.',
      mainTitle: 'Communication Claire pour de Meilleurs Soins',
      mainDesc1: 'En matière de santé, chaque mot compte. Nos interprètes médicaux professionnels garantissent que rien ne se perd dans la traduction lors de vos consultations et séjours hospitaliers.',
      mainDesc2: 'Nos interprètes ne sont pas que des experts linguistiques – ils sont formés à la terminologie médicale et comprennent le contexte des soins de santé.',
      features: {
        languages: { title: 'Plus de 20 Langues Disponibles', desc: 'Arabe, russe, français, allemand, espagnol, mandarin, japonais, coréen, portugais, swahili et bien d\'autres.' },
        medical: { title: 'Experts en Terminologie Médicale', desc: 'Tous les interprètes sont formés au vocabulaire médical et aux protocoles de soins.' },
        options: { title: 'Options Présentielles et à Distance', desc: 'Choisissez entre l\'accompagnement physique ou l\'interprétation vidéo/téléphonique.' },
        documents: { title: 'Traduction de Documents', desc: 'Traduction de rapports médicaux, ordonnances, résumés de sortie et autres documents essentiels.' },
      },
      servicesInclude: 'Nos Services d\'Interprétation Comprennent',
      servicesList: [
        'Interprétation de consultations médicales',
        'Explications de chirurgies et procédures',
        'Instructions de médication et soins post-op',
        'Assistance à l\'admission hospitalière',
        'Support assurance et facturation',
        'Traduction de rapports médicaux',
        'Traduction d\'ordonnances',
        'Support d\'urgence sur appel',
        'Interprétation de consultations vidéo',
        'Conseils pharmacie et médicaments',
      ],
      languagesTitle: 'Langues Prises en Charge',
      languagesList: [
        'Arabe', 'Russe', 'Français', 'Allemand', 'Espagnol', 'Mandarin', 
        'Japonais', 'Coréen', 'Portugais', 'Swahili', 'Turc', 'Persan',
        'Bengali', 'Ourdou', 'Indonésien', 'Vietnamien', 'Thaïlandais', 'Italien',
        'Néerlandais', 'Polonais'
      ],
      languagesNote: 'Vous ne voyez pas votre langue? Contactez-nous – nous pouvons organiser des interprètes pour la plupart des langues.',
    },
    
    surroundingTours: {
      title: 'Visites Gratuites des Environs',
      subtitle: 'Profitez au maximum de votre voyage médical avec des visites guidées gratuites des attractions voisines pendant votre convalescence.',
      mainTitle: 'Guérir par l\'Exploration',
      mainDesc1: 'La guérison ne se limite pas au traitement médical – il s\'agit aussi de rajeunir votre esprit. Nous croyons que découvrir la riche culture et la beauté naturelle de l\'Inde peut faire partie de votre parcours de guérison.',
      mainDesc2: 'Que vous soyez intéressé par les monuments historiques, les temples sereins, les marchés animés ou les jardins paisibles, nos guides locaux vous feront découvrir les merveilles de l\'Inde.',
      features: {
        guides: { title: 'Guides Locaux Experts', desc: 'Guides compétents partageant des histoires fascinantes sur chaque destination.' },
        itineraries: { title: 'Itinéraires Adaptés', desc: 'Visites conçues avec pauses, options d\'accessibilité et rythme adapté aux patients en convalescence.' },
        cuisine: { title: 'Cuisine Authentique', desc: 'Dégustez des délices locaux avec prise en compte des restrictions alimentaires liées à votre traitement.' },
        flexible: { title: 'Horaires Flexibles', desc: 'Visites organisées autour de votre programme de traitement et recommandations du médecin.' },
      },
      popularDestinations: 'Destinations Touristiques Populaires',
      mumbaiRegion: 'Région de Mumbai',
      delhiRegion: 'Région de Delhi',
      includedTitle: 'Ce qui est Inclus dans Votre Visite',
      includedList: [
        'Transport climatisé',
        'Guide local professionnel',
        'Droits d\'entrée aux monuments',
        'Eau en bouteille',
        'Collations légères',
        'Accès fauteuil roulant si nécessaire',
        'Assistance photo',
        'Contact médical d\'urgence',
      ],
    },
    
    nursingCare: {
      title: 'Services de Soins Infirmiers',
      subtitle: 'Soins infirmiers professionnels à votre hébergement pour une expérience de convalescence confortable et sûre.',
      mainTitle: 'Soins Attentionnés, Où que Vous Soyez',
      mainDesc1: 'La convalescence ne s\'arrête pas quand vous quittez l\'hôpital. Notre service de soins infirmiers professionnels apporte des soins médicaux de qualité hospitalière directement à votre chambre d\'hôtel.',
      mainDesc2: 'Que vous ayez besoin d\'aide pour les soins de plaies, la gestion des perfusions, les exercices de kiné, ou simplement quelqu\'un pour surveiller vos constantes et votre traitement, nos infirmières fournissent des soins attentifs.',
      features: {
        registered: { title: 'Infirmières Diplômées', desc: 'Toutes nos infirmières sont des professionnelles diplômées avec expérience en réanimation, chirurgie et soins à domicile.' },
        location: { title: 'Soins à Votre Emplacement', desc: 'Visites infirmières à votre hôtel, appartement ou tout hébergement de votre choix.' },
        flexible: { title: 'Horaires Flexibles', desc: 'Choisissez parmi les visites horaires, les soins journaliers ou les soins 24h/24 selon vos besoins.' },
        emergency: { title: 'Réponse d\'Urgence', desc: 'Formées pour gérer les urgences avec communication directe avec votre équipe médicale.' },
      },
      servicesTitle: 'Nos Services Infirmiers Comprennent',
      servicesList: [
        'Surveillance des constantes (TA, température, pouls, oxygène)',
        'Administration et gestion des médicaments',
        'Soins de plaies et changements de pansements',
        'Thérapie IV et injections',
        'Soins et gestion des cathéters',
        'Soins et surveillance post-opératoires',
        'Gestion du diabète et administration d\'insuline',
        'Gestion de la douleur',
        'Aide à la mobilité et activités quotidiennes',
        'Surveillance alimentaire et nutritionnelle',
        'Coordination avec vos médecins',
        'Première réponse aux urgences médicales',
      ],
      packagesTitle: 'Options de Forfaits de Soins',
      hourlyVisits: { title: 'Visites Horaires', desc: 'Visites programmées pour des soins spécifiques', features: ['Sessions de 1-4 heures', 'Idéal pour soins de plaies', 'Aide aux médicaments'] },
      dayCare: { title: 'Soins de Jour', desc: 'Support infirmier de 8-12 heures', features: ['Surveillance diurne', 'Multiples tâches de soins', 'Aide aux activités'] },
      fullCare: { title: 'Soins 24h/24', desc: 'Soins infirmiers en continu', features: ['Surveillance continue', 'Soins de nuit inclus', 'Support complet'] },
    },
    
    physiotherapist: {
      title: 'Services de Kinésithérapie',
      subtitle: 'Services experts de kinésithérapie pour accélérer votre récupération et restaurer votre mobilité.',
      mainTitle: 'Restaurer la Mobilité, Reconstruire la Force',
      mainDesc1: 'La kinésithérapie est un composant crucial de la récupération pour de nombreuses procédures médicales, notamment les chirurgies orthopédiques et les traitements neurologiques.',
      mainDesc2: 'Que vous ayez besoin de séances dans votre chambre ou de visites dans un centre de kinésithérapie voisin, nous organisons des plans de traitement personnalisés conçus en consultation avec votre chirurgien.',
      features: {
        certified: { title: 'Spécialistes Certifiés', desc: 'Kinésithérapeutes agréés spécialisés en réhabilitation post-chirurgicale et médecine sportive.' },
        personalized: { title: 'Programmes Personnalisés', desc: 'Plans de traitement adaptés à votre chirurgie spécifique, condition et objectifs de récupération.' },
        equipment: { title: 'Équipement Moderne', desc: 'Accès à des équipements et techniques de kinésithérapie avancés.' },
        flexible: { title: 'Séances Flexibles', desc: 'Visites en chambre, séances en clinique ou arrangements hybrides selon votre préférence.' },
      },
      specializationsTitle: 'Nos Spécialisations en Kinésithérapie',
      specializationsList: [
        'Réhabilitation post-prothèse de genou',
        'Récupération prothèse de hanche',
        'Réhabilitation chirurgie du rachis',
        'Thérapie épaule et coiffe des rotateurs',
        'Réhabilitation cardiaque',
        'Kinésithérapie neurologique',
        'Récupération blessures sportives',
        'Réhabilitation post-AVC',
        'Renforcement pré-chirurgical',
        'Équilibre et prévention des chutes',
        'Thérapie gestion de la douleur',
        'Exercices d\'amplitude articulaire',
      ],
      journeyTitle: 'Votre Parcours de Kinésithérapie',
      journeySteps: [
        { title: 'Évaluation Initiale', desc: 'Évaluation complète de votre condition, mobilité et objectifs en consultation avec votre équipe médicale.' },
        { title: 'Plan Personnalisé', desc: 'Développement d\'un plan de traitement personnalisé avec exercices spécifiques et jalons.' },
        { title: 'Séances Régulières', desc: 'Séances guidées de kinésithérapie à votre hébergement ou centre voisin.' },
        { title: 'Suivi des Progrès', desc: 'Évaluation régulière des améliorations avec ajustements de votre plan.' },
        { title: 'Programme d\'Exercices à Domicile', desc: 'Avant votre départ, recevez un guide complet d\'exercices pour continuer la récupération chez vous.' },
      ],
    },
    
    travelAccommodation: {
      title: 'Organisation Voyage et Hébergement',
      subtitle: 'Planification complète de voyage et séjours confortables près de votre hôpital – tout organisé pour vous.',
      mainTitle: 'Votre Confort est Notre Priorité',
      mainDesc1: 'Planifier un voyage médical implique plus que choisir un hôpital. Des réservations de vols à trouver le lieu idéal pour séjourner, nous gérons toute votre logistique de voyage.',
      mainDesc2: 'Que vous préfériez une maison d\'hôtes économique, un hôtel confortable ou un appartement meublé pour les longs séjours, nous avons des partenariats avec des hébergements qui comprennent les besoins des voyageurs médicaux.',
      features: {
        flights: { title: 'Assistance Vols', desc: 'Aide pour trouver les meilleurs vols, documentation visa et demandes d\'assistance spéciale.' },
        hotels: { title: 'Séjours Sélectionnés', desc: 'Hôtels et appartements sélectionnés près des hôpitaux, vérifiés pour confort et commodité.' },
        location: { title: 'Emplacements Privilégiés', desc: 'Hébergements à proximité facile des hôpitaux, pharmacies et services essentiels.' },
        quality: { title: 'Qualité Assurée', desc: 'Tous les hébergements inspectés pour propreté, sécurité et accueil des voyageurs médicaux.' },
      },
      accommodationTypes: 'Options d\'Hébergement',
      guesthouse: { title: 'Maisons d\'Hôtes', desc: 'Abordables, propres et confortables', features: ['Commodités de base', 'Près des hôpitaux', 'Cuisine maison', 'Service familial'] },
      hotels: { title: 'Hôtels (3-5 Étoiles)', desc: 'Confort et services premium', features: ['Room service 24h/24', 'Assistance conciergerie', 'Restaurant et café', 'Ménage quotidien'] },
      apartments: { title: 'Appartements Meublés', desc: 'Chez-soi loin de chez soi', features: ['Cuisine complète', 'Espace de vie', 'Réductions long séjour', 'Familial'] },
      arrangementsTitle: 'Ce que Nous Organisons Pour Vous',
      arrangementsList: [
        'Assistance réservation de vols',
        'Conseils visa médical',
        'Sélection et réservation hébergement',
        'Coordination navette aéroport',
        'Organisation carte SIM locale',
        'Conseils change de devises',
        'Orientation zone locale',
        'Configuration contacts d\'urgence',
        'Arrangements prolongation de séjour',
        'Hébergement accompagnant',
        'Communication exigences alimentaires',
        'Cartographie proximité hôpital',
      ],
      citiesTitle: 'Principales Villes de Destination Médicale',
    },
    
    videoConsultations: {
      title: 'Consultations Vidéo',
      subtitle: 'Connectez-vous avec les meilleurs spécialistes indiens depuis n\'importe où dans le monde via des appels vidéo sécurisés.',
      mainTitle: 'Avis Médical Expert, Où que Vous Soyez',
      mainDesc1: 'Pas sûr de devoir voyager en Inde pour un traitement? Commencez votre parcours par une consultation vidéo. Notre plateforme sécurisée de télésanté vous connecte avec les meilleurs spécialistes indiens.',
      mainDesc2: 'Les consultations vidéo sont parfaites pour les évaluations initiales, la planification de traitement, les seconds avis et les suivis post-traitement.',
      features: {
        global: { title: 'Accessibilité Mondiale', desc: 'Connectez-vous depuis n\'importe quel pays, n\'importe quel fuseau horaire. Nous planifions des rendez-vous qui vous conviennent.' },
        secure: { title: 'Conforme HIPAA', desc: 'Appels vidéo cryptés de bout en bout garantissant la confidentialité de vos informations médicales.' },
        flexible: { title: 'Horaires Flexibles', desc: 'Créneaux tôt le matin ou tard le soir pour s\'adapter aux différents fuseaux horaires.' },
        easy: { title: 'Facile à Utiliser', desc: 'Plateforme simple fonctionnant sur téléphone, tablette ou ordinateur. Aucun logiciel spécial requis.' },
      },
      howItWorks: 'Comment Fonctionne la Consultation Vidéo',
      steps: [
        { title: 'Réservez Votre Rendez-vous', desc: 'Soumettez votre demande avec vos rapports médicaux. Notre équipe vous mettra en relation avec le bon spécialiste.' },
        { title: 'Examen des Documents', desc: 'Le spécialiste examine vos rapports avant l\'appel pour optimiser votre temps de consultation.' },
        { title: 'Consultation Vidéo', desc: 'Rejoignez l\'appel vidéo sécurisé à l\'heure prévue. Discutez de votre condition, posez des questions et obtenez des conseils experts.' },
        { title: 'Résumé Écrit', desc: 'Recevez un résumé détaillé de la consultation avec diagnostic, recommandations et prochaines étapes.' },
        { title: 'Support de Suivi', desc: 'Notre équipe reste disponible pour vous aider à comprendre les recommandations et planifier votre traitement.' },
      ],
      consultationTypes: 'Types de Consultations Vidéo',
      typesList: [
        'Évaluation médicale initiale',
        'Consultation second avis',
        'Discussion planification traitement',
        'Consultation pré-chirurgicale',
        'Suivi post-traitement',
        'Examen référence spécialiste',
        'Interprétation rapports médicaux',
        'Estimation coûts traitement',
        'Évaluation faisabilité chirurgie',
        'Gestion maladies chroniques',
      ],
      specialtiesTitle: 'Spécialités Disponibles pour Consultation Vidéo',
    },
  },
  
  // Treatments Page
  treatments: {
    heroTitle: 'Traitements Médicaux',
    heroTitleHighlight: 'de Classe Mondiale',
    heroSubtitle: "L'Inde offre des traitements médicaux avancés à une fraction du coût. Explorez notre gamme complète de spécialités et procédures.",
    jciAccredited: 'Hôpitaux Accrédités JCI',
    costSavings: '60-80% d\'Économies',
    expertSurgeons: 'Chirurgiens Experts',
    filters: 'Filtres',
    showing: 'Affichage',
    treatmentsCount: 'traitements',
    commonProcedures: 'Procédures Courantes',
    learnMore: 'En Savoir Plus',
    savingsCompared: 'd\'économies par rapport aux USA',
  },
  
  // Doctors Page
  doctors: {
    heroTitle: 'Connectez-vous avec les',
    heroTitleHighlight: 'Meilleurs Médecins d\'Inde',
    heroSubtitle: 'Spécialistes hautement qualifiés avec formation internationale et années d\'expérience dans leurs domaines.',
    filterDoctors: 'Filtrer Médecins',
    hideFilters: 'Masquer Filtres',
    showFilters: 'Afficher Filtres',
    city: 'Ville',
    allCities: 'Toutes les Villes',
    state: 'État',
    allStates: 'Tous les États',
    specialization: 'Spécialisation',
    allSpecializations: 'Toutes les Spécialités',
    experience: 'Expérience',
    anyExperience: 'Toute Expérience',
    yearsPlus: 'ans+',
    showing: 'Affichage',
    doctorsCount: 'médecins',
    yearsExperience: 'ans d\'expérience',
    viewProfile: 'Voir Profil',
    requestAppointment: 'Demander Rendez-vous',
    noResults: 'Aucun médecin trouvé correspondant à vos critères',
    tryAdjusting: 'Essayez d\'ajuster vos filtres pour voir plus de résultats',
    clearFilters: 'Effacer Filtres',
  },
  
  // Hospitals Page
  hospitals: {
    heroTitle: 'Les Meilleurs',
    heroTitleHighlight: 'Hôpitaux d\'Inde',
    heroSubtitle: 'Hôpitaux accrédités JCI avec infrastructure de classe mondiale, technologie de pointe et soins exceptionnels aux patients dans 9 états.',
    hospitalsCount: 'Hôpitaux',
    jciAccredited: 'Accrédités JCI',
    expertTeams: 'Équipes Médicales Expertes',
    filters: 'Filtres',
    showing: 'Affichage',
    hospitalsCountLabel: 'hôpitaux',
    bedCapacity: 'Capacité de Lits',
    viewHospital: 'Voir Hôpital',
    specialties: 'Spécialités',
    accreditations: 'Accréditations',
  },
  
  // Wellness Page
  wellness: {
    heroTitle: 'Bien-être Holistique et',
    heroTitleHighlight: 'Récupération',
    heroSubtitle: 'Combinez un traitement médical de classe mondiale avec les anciennes traditions de bien-être de l\'Inde pour une guérison complète du corps, de l\'esprit et de l\'âme.',
    ayurveda: 'Ayurveda',
    yoga: 'Yoga et Méditation',
    naturopathy: 'Naturopathie',
    spa: 'Spa et Rajeunissement',
    whyChoose: 'Pourquoi Choisir l\'Inde pour le Bien-être',
    healingTraditions: 'L\'Inde a une tradition de 5 000 ans de guérison holistique à travers l\'Ayurveda, le yoga et la naturopathie.',
    integratedCare: 'Nos programmes de bien-être sont conçus pour compléter votre traitement médical et accélérer la récupération.',
  },
  
  // Medical Visa Page
  medicalVisa: {
    heroTitle: 'Assistance',
    heroTitleHighlight: 'Visa Médical',
    heroSubtitle: 'Nous vous guidons tout au long du processus de visa médical, rendant votre voyage de santé en Inde fluide et sans tracas.',
    whatIs: 'Qu\'est-ce qu\'un Visa Médical?',
    whatIsDesc: 'Un visa médical (M-Visa) est délivré aux ressortissants étrangers cherchant un traitement médical en Inde. Il permet des entrées multiples et est valide jusqu\'à un an.',
    eligibility: 'Éligibilité',
    eligibilityDesc: 'Patients cherchant un traitement dans des hôpitaux indiens reconnus',
    validity: 'Validité',
    validityDesc: 'Jusqu\'à 1 an ou 3 fois la durée du traitement',
    entries: 'Entrées',
    entriesDesc: 'Triple entrée, extensible',
    attendants: 'Accompagnants',
    attendantsDesc: 'Jusqu\'à 2 visas d\'accompagnant médical (MX-Visa)',
    documentsRequired: 'Documents Requis',
    howWeHelp: 'Comment Nous Aidons',
  },
};

export default fr;
